import React from 'react';
import * as mobxReact from 'mobx-react';
import * as mobx from 'mobx';
import { FormattedMessage, injectIntl, IntlShape, useIntl } from 'react-intl';
import classnames from 'classnames';
import { ICustomFieldsDTO } from '../../../../../../../../api/custom-fields.dao';
import { FormField } from '../../../../../../../global/form/form-field/form-field';
import { ChevronUpIcon, LockIcon } from '../../../../../../../global/icons/icons';
import { OEToggle } from '../../../../../../../global/oe-toggle/oe-toggle';
import Text from '../../../../../../../global/text/text';
import CustomFieldVM from '../custom-field.viewmodel';

interface IProps {
    field: ICustomFieldsDTO;
    intl: IntlShape;
    customFieldsArray?: ICustomFieldsDTO[];
    updateField: (id: number, field: ICustomFieldsDTO) => void;
    getFieldErrorMessage: (text: string, isMandatory?: boolean, isAlphaNumeric?: boolean) => string;
    vm: CustomFieldVM;
    toggleVisibility: (id: number, field: ICustomFieldsDTO) => string | null;
}

export const FieldToggle = {
    displayed: 'Field is displayed',
    hidden: ' is hidden'
};

export const CustomFieldName = injectIntl(mobxReact.observer((props: IProps): JSX.Element => {
    const { field, updateField, getFieldErrorMessage, vm } = props;
    const { formatMessage } = useIntl();

    const {
        group: nameGroup,
        defaultFieldId,
        isCollapsed,

    } = field;
    const [{ visible }] = nameGroup;

    const updateNameFields = mobx.action((id, property, value) => {
        field.group = nameGroup.map(currentField =>
            currentField.defaultFieldId === id ? { ...currentField, [property]: value } : currentField
        );

        updateField(defaultFieldId, field);
    });

    const toggleCollapse = mobx.action(() =>
        updateField(defaultFieldId, { ...field, isCollapsed: !isCollapsed})
    );

    const collapseChevronClasses = classnames({
        'collapsed': isCollapsed,
        'centered': !visible
    });

    return (
        <div className={collapseChevronClasses}>
            <div className='custom-field__content'>
                <label onClick={toggleCollapse} className='custom-field__title'>
                    Name  <ChevronUpIcon/>
                </label>
                {!isCollapsed &&
                    <div className='custom-field__list'>
                        {nameGroup.map(({ defaultFieldTitle, defaultFieldId: id, label }) => {
                            return (
                                <div key={`group-${id}`}>
                                    <label className='m-bottom-15px website-custom__title'>
                                        {defaultFieldTitle}
                                    </label>
                                    <FormField
                                        labelFor={`label-${id}`}
                                        className='m-bottom-20px'
                                        label={<FormattedMessage
                                            id='oe.label.fieldLabel'
                                            description='Label text'
                                            defaultMessage='Field Label'
                                        />}
                                    >
                                        <input
                                            id={`label-${id}`}
                                            className='oe-form-field__control'
                                            value={label}
                                            type='text'
                                            onChange={({ target: { value } }) =>
                                                updateNameFields(id, 'label', value)
                                            }
                                        />
                                        {getFieldErrorMessage(label, true) &&
                                            <span className='oe-form-field__error'>
                                                <FormattedMessage
                                                    id='oe.label.fieldLabelError'
                                                    description='Label text'
                                                    defaultMessage='Field Label {suffix}'
                                                    values={{
                                                        suffix: getFieldErrorMessage(label, true)
                                                    }}
                                                />
                                            </span>
                                        }
                                    </FormField>
                                </div>
                            );
                        })}
                        {vm.canFieldBeHidden(field) && <FormField className='m-bottom-20px'>
                            <div className='website-custom__toggle'>
                                <OEToggle
                                    isSelected={vm.isFieldVisible(field)}
                                    onClick={() => props.toggleVisibility(field.defaultFieldId, field)}
                                />
                                <Text message={formatMessage({
                                    id: 'oe.customFields.fieldIsdisplayed',
                                    defaultMessage: FieldToggle.displayed,
                                    description: 'Field visibility label'
                                })} />
                            </div>
                        </FormField>}
                    </div>
                }
                {!vm.canFieldBeHidden(field) &&
                    <div className='custom-field__lock-icon'>
                        <LockIcon/>
                    </div>
                }
            </div>
        </div>
    );


}));
